var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.79 57.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e12c42;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.75,58.07a14.29,14.29,0,1,0-15.76,0A22.89,22.89,0,0,0,14,79.51h3.81a19.06,19.06,0,0,1,38.12,0h3.81A22.91,22.91,0,0,0,44.75,58.07Zm-7.88-1.42A10.49,10.49,0,1,1,47.35,46.16,10.5,10.5,0,0,1,36.87,56.65Z",
    transform: "translate(-14 -22.34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.81,48.55A14.28,14.28,0,1,0,46.08,26.3a14.57,14.57,0,0,0-2.45,3.08A18.11,18.11,0,0,1,47,31.17a10.54,10.54,0,0,1,8.93-5,10.48,10.48,0,0,1,2.83,20.57,10.63,10.63,0,0,1-2.83.4c-.34,0-.67,0-1,0a18.68,18.68,0,0,1-.64,4c.54,0,1.08-.12,1.64-.12A19.17,19.17,0,0,1,75,70h3.81A22.88,22.88,0,0,0,63.81,48.55Z",
    transform: "translate(-14 -22.34)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacity);
export default __webpack_public_path__ + "static/media/capacity.d4487a0e.svg";
export { ForwardRef as ReactComponent };